export default __webpack_public_path__ + "static/media/ipfire.d0275d48.png";